import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class PaymentService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  getPaypalLink(yearly?: boolean): Observable<string> {
    const url = yearly ? this.api.PAYMENT_YEARLY() : this.api.PAYMENT_MONTHLY();
    return this.http.get<{ link: string }>(url).pipe(map((data) => data.link));
  }

  sendAppleStoreData(data: any): Observable<any> {
    const url = this.api.PAYMENT_APPLE_STORE();
    return this.http.post(url, data)
  }

  sendGoogleStoreData(data: any): Observable<any> {
    const url = this.api.PAYMENT_GOOGLE_STORE();
    return this.http.post(url, data)
  }

}
